import { render, staticRenderFns } from "./PromotionRateValue.vue?vue&type=template&id=f2d082ac&"
import script from "./PromotionRateValue.vue?vue&type=script&lang=ts&"
export * from "./PromotionRateValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports